import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CompanyStaffsContext } from 'contexts/CompanyStaffsContext'
import { AbilityContext } from 'contexts/abilityContext'

import { Button, Collapse, Modal } from 'antd'

import { ExternalStaffs } from './ExternalStaffs'
import { ManagementStaffs } from './ManagementStaffs'
import { SharesStaffs } from './SharesStaffs'
import { StaffBoxCardEdit } from './Cards/StaffBoxCardEdit'

import { StaffBox } from './styles'

const StaffCollapses = () => {
  const { t } = useTranslation('companyStaffs')
  const { Panel } = Collapse
  const { staffs } = useContext(CompanyStaffsContext)
  const ability: any = useContext(AbilityContext)
  const [modalOpen, setModalOpen] = useState(false)

  if ((staffs || []).length === 0) return <StaffBox>{t('noItem')}</StaffBox>

  return (
    <>
      <Collapse defaultActiveKey={['management']}>
        <Panel header={t('types.management')} key="management">
          <ManagementStaffs />
        </Panel>
        <Panel header={t('types.shareholders')} key="shareholders">
          <SharesStaffs />
        </Panel>
        <Panel header={t('types.extern')} key="extern">
          <ExternalStaffs />
        </Panel>
      </Collapse>
      {/*CREATION MODAL*/}
      {ability.can('manage', 'CompanyStaff') && (
        <>
          <Button onClick={() => setModalOpen(true)}>
            {t('submit.create')}
          </Button>
          <Modal
            title={t(`modal.title`)}
            centered
            open={modalOpen}
            okButtonProps={{ style: { display: 'none' } }}
            onCancel={() => setModalOpen(false)}
          >
            <StaffBoxCardEdit />
          </Modal>
        </>
      )}
      {/*CREATION MODAL*/}
    </>
  )
}

export default StaffCollapses
